import './FileStripe.scss';
import { ReactElement } from 'react';
import { CrossIcon } from '../../../../design/static/icons/CrossIcon';
import { SpaceBetweenLayout } from '../../../common/layouts/spaceBetweenLayout/SpaceBetweenLayout';

interface IFileStripeProps {
  fileName: string;
  onRemoveFileClicked: () => void;
}

export const FileStripe = ({ fileName, onRemoveFileClicked }: IFileStripeProps): ReactElement => (
  <SpaceBetweenLayout className='file-stripe'>
    <div className='file-name'>{fileName}</div>
    <div
      className='remove-file'
      onClick={onRemoveFileClicked}
    >
      <CrossIcon />
    </div>
  </SpaceBetweenLayout>
);
